import { Controller } from "stimulus"
import StimulusReflex from 'stimulus_reflex';

let MOBILE_MAX_CAPACITIES = [
  {
    service: "airtel",
    regex: /^(9[6-9]|8[6-9]|77)[0-9]{6}$/,
    capacity: 1000000.0
  },
  {
    service: "moov",
    regex: /^(9[4-5]|8[4-5]|7[4-5])[0-9]{6}$/,
    capacity: 1000000.0
  },
  {
    service: "zamani",
    regex: /^(9[0-2]|8[0-2]|70)[0-9]{6}$/,
    capacity: 1000000.0
  },
]

let STA_MAX_CAPACITIES = [
  {
    service: "alizza",
    capacity: 0.0
  },
  {
    service: "amanata",
    capacity: 5000000.0
  },
  {
    service: "nita_online",
    capacity: 5000000.0
  },
]

export default class extends Controller {

  static values = {
    paymentListId: Number,
    amount: Number,
    statusUrl: String
  }

  static targets = [ "phone", "modal", "message", "pay", "staCode" ]

  initialize() {
    StimulusReflex.register(this);
  }

  connect() {
    this.setMaxValues(!this.isDevelomentEnvironment() ? 500 : 1000000)
    this.body = document.querySelector('body');
    this.boundReloadPaymentsListPage = this.reloadPaymentsListPage.bind(this);
    this.body.addEventListener("paymentsList:payment:updated", this.boundReloadPaymentsListPage);
    this.boundShowStaCode = this.showStaCode.bind(this);
    this.body.addEventListener("payment:sta_code:updated", this.boundShowStaCode);
    this.loadStaCode();
  }

  disconnect() {
    if (this.body && this.boundReloadPaymentsListPage) {
      this.body.removeEventListener("paymentsList:payment:updated", this.boundReloadPaymentsListPage);
    }
    if (this.body && this.boundShowStaCode) {
      this.body.removeEventListener("payment:sta_code:updated", this.boundShowStaCode);
    }
  }

  // Code NITA poussé par le serveur (CableReady) : pas de rechargement ni de polling.
  showStaCode(e) {
    const { paymentsListId, staCode } = e.detail;
    if (this.paymentListIdValue != paymentsListId || !staCode || !this.hasStaCodeTarget) return;

    this.staCodeTarget.textContent = staCode;
  }

  reloadPaymentsListPage(e) {
    const paymentListId = e.detail['paymentsListId'];
    if (this.paymentListIdValue == paymentListId) {
      this.stimulate('PaymentsListReflex#reload', paymentListId);
    }
  }

  // Une seule requête à l'ouverture : couvre le code déjà généré avant l'arrivée
  // sur la page (l'évènement serait alors passé inaperçu).
  async loadStaCode() {
    if (!this.hasStatusUrlValue || !this.hasStaCodeTarget) return;

    const currentCode = this.staCodeTarget.textContent.trim();
    if (currentCode !== "" && currentCode !== "En attente...") return;

    try {
      const response = await fetch(this.statusUrlValue, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) return;

      const paymentData = await response.json();

      if (!paymentData.has_pending_payment || paymentData.provider !== 'nita_online') return;

      if (paymentData.sta_code) {
        this.staCodeTarget.textContent = paymentData.sta_code;
      }
    } catch (error) {
      return;
    }
  }

  checkCapacity(e) {
    const selectedProvider = this.element.querySelector('input[name="payment[provider]"]:checked')?.value;
    const phoneNotEmpty = this.phoneTarget.value !== "";
  
    if (phoneNotEmpty) {
      if (selectedProvider === "mobile") {
        const operator = MOBILE_MAX_CAPACITIES.find((op) => op.regex.test(this.phoneTarget.value));
    
        if (operator && this.amountValue > operator.capacity) {
          this.showMessage(`Le montant ne doit pas excéder ${operator.capacity} pour ${operator.service}.`);
        } else if (operator) {
          this.payTarget.click();
        } else {
          this.showMessage("Ce numéro de téléphone n'est pas reconnu.");
        }
      } else if (selectedProvider === "alizza") {
        this.processSta("alizza");
      } else if (selectedProvider === "amanata") {
        this.processSta("amanata");
      } else if (selectedProvider === "nita_online") {
        this.processSta("nita_online");
      } else {
        this.showMessage("Ce service n'est pas pris en charge.");
      }
    } else {
      this.showMessage("Vous devez renseigner un numéro de téléphone");
    }
  }

  processSta(staName) {
    const operator = STA_MAX_CAPACITIES.find((op) => op.service == staName);
    
    if (operator && this.amountValue > operator.capacity) {
      this.showMessage(`Le montant ne doit pas excéder ${operator.capacity} pour ${staName}.`);
    } else
    if (operator) {
      this.payTarget.click();
    } else {
      this.showMessage("Ce service n'est pas pris en charge.");
    }
  }
  
  showMessage(message) {
    this.messageTarget.innerHTML = message;
    this.modalTarget.style.display = "flex";
  }
  
  close(e) {
    e.preventDefault();
    this.modalTarget.style.display = "none";
  }

  setMaxValues(value){
    STA_MAX_CAPACITIES.concat(MOBILE_MAX_CAPACITIES).forEach(service => {
      service.capacity = value
    })
  }

  isDevelomentEnvironment() {
    return document.head.querySelector("meta[name=rails_env]").content == "development"
  }
  
}
